<!-- 我的订单   未完成  -查看详情 -->
<template >
  <div class="orderpaycontain" :style="$store.state.equipment.height">
    <!-- <div class="orderheader">查看</div> -->
    <!-- <div id="top">
      
   <header-box title='查看'></header-box>    
   
    </div> -->
    <!-- <div class="ordernav"><span class="nopay" @click="nopay">未支付</span><span @click="ispay" class="ispay">已完成</span></div> -->

    <div class="ordernum">
      <span style="color: #787878; font-size: 14px" class="examl"
        >订单编号：</span
      ><span class="examr">{{ this.$route.query.transOrder.orderNo }}</span>
      <span
        class="ordernum_ing"
        v-if="this.$route.query.transOrder.payType != null"
        >订单已完成</span
      >
      <span
        class="ordernum_ing"
        v-if="this.$route.query.transOrder.payType == null"
        >订单未付款</span
      >
      <!-- <span v-else class="ordernum_ing">订单已完成</span> -->
    </div>
    <div class="orderbottom">
      <div class="ordercontent">
        <span class="examl">批次名称</span>
        <span class="examr">{{
          this.$route.query.transOrder.appraisalBatchName
        }}</span>
      </div>
      <div class="ordercontent">
        <span class="examl">考试科目</span>
        <span class="examr">{{
          this.$route.query.transOrder.subjectName
        }}</span>
      </div>
      <div class="ordercontent">
        <span class="examl">考试工种</span>
        <span class="examr">{{ this.$route.query.transOrder.occupation }}</span>
      </div>
      <div class="ordercontent">
        <span class="examl">考试等级</span>
        <span class="examr">{{ this.$route.query.transOrder.skillLevel }}</span>
      </div>
      <div
        class="ordercontent"
        v-if="this.$route.query.transOrder.examTime != null"
      >
        <span class="examl">理论考试时间</span>
        <span class="examr">{{ this.$route.query.transOrder.examTime }}</span>
      </div>
      <div
        class="ordercontent"
        v-if="this.$route.query.transOrder.liveTime != null"
      >
        <span class="examl">实操考试时间</span>
        <span class="examr">{{ this.$route.query.transOrder.liveTime }}</span>
      </div>
      <div class="ordercontent">
        <span class="examl">考生名称</span>
        <span class="examr">{{ this.$route.query.transOrder.payerName }}</span>
      </div>
       <div class="ordercontent"><span class="examl">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 性别</span> <span class="examr">{{this.$route.query.transOrder.sex}}</span></div>

       <div class="ordercontent"><span class="examl">联系方式</span> <span class="examr">{{this.$route.query.transOrder.mobile}}</span></div>

      <div class="ordercontent">
        <span class="examl">付款方式</span>
        <span
          class="examr"
          v-if="this.$route.query.transOrder.payType == 'onlinePay'"
          >线上支付</span
        >
        <span
          class="examr"
          v-if="this.$route.query.transOrder.payType == 'payByBankCard'"
          >银行卡支付</span
        >
        <span class="examr" v-if="this.$route.query.transOrder.payType == null"
          >未付款</span
        >
      </div>
      <div class="ordercontent">
        <span class="examl">付款金额</span>
        <span class="examr">{{ this.$route.query.transOrder.goodsPrice }}</span>
      </div>
      <div
        class="ordercontent"
        v-if="this.$route.query.transOrder.payType != null"
      >
        <span class="examl">付款时间</span>
        <span class="examr">{{
          $moment(this.$route.query.transOrder.payTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import headerBox from "@/components/header.vue";
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      shownopay: false,
    };
  },
  methods: {},
  mounted() {
    this.shownopay = Number(this.$route.query.lookbool);
  },
};
</script>
<style lang="less" scoped>
.orderpaycontain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 32px;
  background: rgb(228, 228, 230);
  width: 100%;
  height: 100vh;
}
#top {
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color: @backgroundcolor;
  padding-bottom: @headerpb;
}
.orderpaycontain .orderheader {
  text-align: center;
}

.orderpaycontain .ordernum {
  position: relative;
  background: white;
  border-bottom: 1px solid #edebeb;
}
.orderpaycontain .ordernum_ing {
  position: absolute;
  right: @paddingpay;
  top: 0;
  color: rgb(182, 179, 179);
}

.orderpaycontain .orderbottom {
  background: white;
  border: 1px 0 1px 0 solid wheat;
}
.orderpaycontain .orderbottom .ordercontent .examl {
  padding: 0 0 20px 0;
  color: rgb(182, 179, 179);
  width: 200px;
  font-size: 28px;
}
.orderpaycontain .orderbottom .ordercontent {
  display: flex;
}
.orderpaycontain .orderbottom .ordercontent .examr {
  color: black;
  flex: 1;
  padding: 0 0 20px 0;
}
.orderpaycontain .ordernum {
  height: 76px;
  line-height: 76px;
}
.orderpaycontain .ordernum,
.orderpaycontain .orderbottom {
  padding: 0 @paddingpay;
}

.orderbottom .ordercontent:nth-child(1) {
  padding-top: @paddingpay;
}
</style>
